import React from 'react';
import CommonGrid from './CommonGrid';
import { ColumnType } from '../../../../components/Grid/constants';

const BulkImportsGrid = (props) => {
  const columns = [
    {
      field: 'fileName',
      label: 'Název souboru',
      type: ColumnType.TEXT,
      width: '35%',
    },
    {
      field: 'created',
      label: 'Datum importu',
      type: ColumnType.DATETIME,
      width: '20%',
    },
    {
      field: 'status',
      label: 'Stav importu',
      type: ColumnType.TEXT,
      width: '20%',
    },
    {
      field: 'importedCount',
      label: 'Počet importovaných funkcionářů',
      type: ColumnType.NUMBER,
      width: '25%',
    },
  ];

  return <CommonGrid {...props} columns={columns} sort="created" />;
};

export default BulkImportsGrid;
